<boi-contextual-help-container [ngClass]="{'has-errors': hasErrors}" [contextualHelpName]="referenceDataLabels.SortCode">
  <boi-validation-error (errorChange)="hasErrors=$event" [propertyNames]="['SortCode']"></boi-validation-error>
  <kendo-textbox-container class="form-element app">
    <div class="form-label app" [boiRequiredFormField]="referenceDataLabels.SortCode">
      <label>{{referenceDataLabels.SortCode | localizeLabel}}</label>
    </div>
    <div class="form-input-container sort-code-container">

      <kendo-numerictextbox class="mr-10" [disabled]="mortgageApplication?.IsApplicationReadOnly" [spinners]="false" [step]="0"
        [(ngModel)]="sortCode1" (focusout)="mortgageApplication.SortCode1 = $event.target.value"
        (keypress)="sortCodeChange($event)" [autoCorrect]="true" [min]="0" [format]="'0#'"
        [boiDisableNumericInputIncrementation]="true"></kendo-numerictextbox>

      <kendo-numerictextbox class="mr-10" [disabled]="mortgageApplication?.IsApplicationReadOnly" [spinners]="false" [step]="0"
        [(ngModel)]="sortCode2" (focusout)="mortgageApplication.SortCode2 = $event.target.value"
        (keypress)="sortCodeChange($event)" [autoCorrect]="true" [min]="0" [format]="'0#'"
        [boiDisableNumericInputIncrementation]="true"></kendo-numerictextbox>

      <kendo-numerictextbox [disabled]="mortgageApplication?.IsApplicationReadOnly" [spinners]="false" [step]="0"
        [(ngModel)]="sortCode3" (focusout)="mortgageApplication.SortCode3 = $event.target.value"
        (keypress)="sortCodeChange($event)" [autoCorrect]="true" [min]="0" [format]="'0#'"
        [boiDisableNumericInputIncrementation]="true"></kendo-numerictextbox>
    </div>
    <boi-tooltip [tooltipName]="referenceDataLabels.SortCode"></boi-tooltip>
  </kendo-textbox-container>
</boi-contextual-help-container>